import { createAction, props } from '@ngrx/store';
import { VerificationResultResponseV1 } from 'src/app/api/models';
import { CacheVerificationType } from 'src/app/requests/request-verifications/verification-cache/verification-cache.models';
import { DetectedField } from 'src/app/requests/request-verifications/verification-cache/verification-field-detector';

export enum VerificationCacheActionTypes {
  AUTO_TRIGGER_VERIFICATIONS = '[VERIFICATION_CACHE] AUTO_TRIGGER_VERIFICATIONS',
  RESET_FOR_REQUEST = '[VERIFICATION_CACHE] RESET_FOR_REQUEST',
  TRIGGER_VERIFICATION = '[VERIFICATION_CACHE] TRIGGER_VERIFICATION',
  REVERIFY = '[VERIFICATION_CACHE] REVERIFY',
  HYDRATE_RESULTS = '[VERIFICATION_CACHE] HYDRATE_RESULTS',
  VERIFICATION_RESPONSE_RECEIVED = '[VERIFICATION_CACHE] VERIFICATION_RESPONSE_RECEIVED',
  VERIFICATION_FAILED = '[VERIFICATION_CACHE] VERIFICATION_FAILED',
  POLL_VERIFICATION = '[VERIFICATION_CACHE] POLL_VERIFICATION',
  POLL_RESULT_RECEIVED = '[VERIFICATION_CACHE] POLL_RESULT_RECEIVED',
  POLL_FAILED = '[VERIFICATION_CACHE] POLL_FAILED',
  POLL_TIMEOUT = '[VERIFICATION_CACHE] POLL_TIMEOUT',
}

export const autoTriggerVerifications = createAction(
  VerificationCacheActionTypes.AUTO_TRIGGER_VERIFICATIONS,
  props<{ requestId: string; forceRefresh?: boolean }>()
);

export const resetVerificationCacheForRequest = createAction(
  VerificationCacheActionTypes.RESET_FOR_REQUEST,
  props<{ requestId: string }>()
);

export const triggerVerification = createAction(
  VerificationCacheActionTypes.TRIGGER_VERIFICATION,
  props<{ requestId: string; field: DetectedField; forceRefresh: boolean }>()
);

export const reverifyField = createAction(
  VerificationCacheActionTypes.REVERIFY,
  props<{ requestId: string; field: DetectedField }>()
);

export const hydrateVerificationResults = createAction(
  VerificationCacheActionTypes.HYDRATE_RESULTS,
  props<{
    requestId: string;
    results: ReadonlyArray<{
      readonly key: string;
      readonly type: CacheVerificationType;
      readonly panelIndex: number;
      readonly response: VerificationResultResponseV1;
      readonly isExpired: boolean;
    }>;
  }>()
);

export const verificationResponseReceived = createAction(
  VerificationCacheActionTypes.VERIFICATION_RESPONSE_RECEIVED,
  props<{
    requestId: string;
    key: string;
    verificationType: CacheVerificationType;
    panelIndex: number;
    response: VerificationResultResponseV1;
  }>()
);

export const verificationFailed = createAction(
  VerificationCacheActionTypes.VERIFICATION_FAILED,
  props<{ requestId: string; key: string; error: unknown }>()
);

export const pollVerification = createAction(
  VerificationCacheActionTypes.POLL_VERIFICATION,
  props<{ requestId: string; key: string; resultId: string }>()
);

export const pollResultReceived = createAction(
  VerificationCacheActionTypes.POLL_RESULT_RECEIVED,
  props<{
    requestId: string;
    key: string;
    response: VerificationResultResponseV1;
  }>()
);

export const pollFailed = createAction(
  VerificationCacheActionTypes.POLL_FAILED,
  props<{ requestId: string; key: string; error: unknown }>()
);

export const pollTimeout = createAction(
  VerificationCacheActionTypes.POLL_TIMEOUT,
  props<{ requestId: string; key: string }>()
);
